import { Helmet } from 'react-helmet'

import { getStepNumber } from 'config/onboarding'
import { getTitle } from 'config/titles'

import Onboarding from 'components/Onboarding'
import { useNetwork } from '~/networkProvider'
import { FacilityScreenContainer } from '~/components/FacilityScreenContainer'

const OnboardingInteriorWallsScreen = () => {
  const { online } = useNetwork()
  return (
    <FacilityScreenContainer>
      <Helmet>
        <title>{getTitle('interiorWalls')}</title>
      </Helmet>
      <Onboarding
        online={online}
        step={getStepNumber('Int. Walls')}
        message="Modify the interior walls of your facility."
      />
    </FacilityScreenContainer>
  )
}

export default OnboardingInteriorWallsScreen
